module.exports = __webpack_public_path__ + "img/action.ba542e98.png";